import React from 'react'
import { Image, Text, HelpIcon, useTooltip } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import history from 'routerHistory'
import { Path } from 'config/constants/paths'
import styled from 'styled-components'
import { ActionButtons, BoostContent } from './styles'

const StyledText = styled(Text)`
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`
interface FarmCardActionsProps {
  disabled?: boolean
}

const XVVSBoostAction: React.FC<FarmCardActionsProps> = ({ disabled = true }) => {
  const { t } = useTranslation()
  const { targetRef, tooltip, tooltipVisible } = useTooltip(t('Lock your xVVS to enjoy additional boost rewards.'), {
    placement: 'top',
  })

  const clickButton = async () => {
    history.push(Path.XVVS_VAULT)
  }

  return (
    <ActionButtons>
      <BoostContent>
        <Image width={30} height={24} src="/images/xVVS/boost-farm-xVVS.png" alt={t('xVVS')} />
        <Text fontSize="13px">{t('xVVS VAULT BOOST')}</Text>
        <span ref={targetRef}>
          <HelpIcon width="16px" height="16px" color="primary" mt="4px" />
        </span>
        {tooltipVisible && tooltip}
      </BoostContent>
      {disabled ? (
        <StyledText textTransform="capitalize" fontSize="16px" color="primary" bold onClick={clickButton}>
          {t('Stake')}
        </StyledText>
      ) : (
        <StyledText textTransform="capitalize" fontSize="16px" color="primary" bold onClick={clickButton}>
          +/- {t('Boost')}
        </StyledText>
      )}
    </ActionButtons>
  )
}

export default XVVSBoostAction
